import React from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { addToCart } from "../../slice/cartSlice";

const CourseDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { courses } = useSelector((state) => state.course);
  const course = courses.find((item) => String(item._id || item.id) === String(id));

  if (!course) return <div className="p-6 text-center">Course not found.</div>;

  const handleAddToCart = () => {
    dispatch(addToCart(course));
    navigate("/cart");
  };

  return (
    <div className="max-w-5xl mx-auto px-6 py-14 bg-white text-gray-900">
      {/* Back Link */}
      <div className="mb-6">
        <Link to="/courses" className="text-sm text-[#345bf3] hover:underline">
          ← Back to Courses
        </Link>
      </div>

      {/* Header Section */}
      <div className="mb-10 border-b pb-6">
        <h1 className="text-4xl font-bold text-[#fc3c04] mb-2">{course.title}</h1>
        <p className="text-lg text-gray-600">{course.teacherName} · {course.language}</p>
      </div>

    

      {/* Info Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-base mb-10">
        <div>
          <p className="font-semibold text-gray-700">Duration</p>
          <p>{course.duration}</p>
        </div>
        <div>
          <p className="font-semibold text-gray-700">Fee</p>
          <p>₹{course.fees}</p>
        </div>
        <div>
          <p className="font-semibold text-gray-700">Start On</p>
          <p>{course.startOn}</p>
        </div>
        <div>
          <p className="font-semibold text-gray-700">Category</p>
          <p>{course.category}</p>
        </div>
      </div>

      {/* Description */}
      <div>
        <h2 className="text-2xl font-semibold text-[#345bf3] mb-3">Course Description</h2>
        <p className="text-gray-700 leading-relaxed text-justify">
          {course.description || "No description provided."}
        </p>
      </div>

      {/* Video Link */}
      {course.videoLink && (
        <div className="mt-6">
          <a
            href={course.videoLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-lg text-[#fc3c04] hover:underline transition"
          >
           Video Link
          </a>
        </div>
      )}

      {/* Add to Cart */}
      <div className="mt-10">
        <button
          onClick={handleAddToCart}
          className="bg-[#345bf3] text-white px-6 py-2 rounded hover:bg-[#fc3c04] transition"
        >
          Add To Cart
        </button>
      </div>
    </div>
  );
};

export default CourseDetail;
